<app-modal title="Senha de Atendimento" [onlyClose]="true">
  <div
    class="tds-u-flex tds-u-justify-center tds-u-flex-dir-col tds-u-align-center tds-u-pr3 tds-u-pl3 tds-text-center"
  >
    <h3 class="tds-headline-01 tds-text-blue-700">Sua senha é:</h3>

    <h1
      class="tds-expressive-headline-02 tds-text-green-200 tds-u-mt1 tds-u-mb2"
    >
      {{ senhaGerada }}
    </h1>

    <p class="tds-body-01 tds-text-black">
      Por favor, dirija-se ao guichê da Segurança e aguarde ser chamado.
    </p>

    <p class="tds-detail-02 tds-text-grey-500 tds-u-mt3">
      Esta tela fechará automaticamente em alguns segundos...
    </p>
  </div>
</app-modal>
